module.exports = __webpack_public_path__ + "ce59c3e71c7c107dad86f0322157c4f9.svg";